import { render, staticRenderFns } from "./Speed.vue?vue&type=template&id=b0b641d8"
import script from "./Speed.vue?vue&type=script&lang=js"
export * from "./Speed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports